export const trimData = (data) => {
  return Object.keys(data).reduce((acc, key) => {
    acc[key] = typeof data[key] === 'string' ? data[key].trim() : data[key];
    return acc;
  }, {});
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: false };
  return date.toLocaleString('en-US', options);
};

export const todayYmd = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
